import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClaimsDataService {
  claimsDetails: any = null;
  private claimsLossDetailsSource = new BehaviorSubject<any>(
    this.claimsDetails
  );
  $claimsLossDetails = this.claimsLossDetailsSource.asObservable();

  updateClaims(claims) {
    this.claimsLossDetailsSource.next(claims);
  }

  clearClaimsData() {
    this.claimsLossDetailsSource.next('');
  }
}
